
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";

import NotificationsIcon from "@mui/icons-material/Notifications";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Paper, MenuItem, IconButton, Badge } from "@mui/material";
import axios from "axios";

import SliderComponent from '../SliderComponent';

const OrderType = {
  TABLE_DINE_IN: "TABLE_DINE_IN",
  TAKEAWAY: "TAKEAWAY",
  DELIVERY: "DELIVERY",
};
const NavBars = ({ showLogin, setShowLogin }) => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [scrolled, setScrolled] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showForgetPassword, setShowForgetPassword] = useState(false);
  const [isForgot, setIsForgot] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginObj, setLoginObj] = useState({
    userName: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [hidePassword, setHidePassword] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  // const [showLogin, setShowLogin] = useState(false);
  const [isSignup, setIsSignup] = useState(false);
  const [isEmailSubmitted, setIsEmailSubmitted] = useState(false);
  const [loginStepStarted, setLoginStepStarted] = useState(false);
  const [emailCheckMessage, setEmailCheckMessage] = useState("");
  const [loading, setLoading] = useState(false); // Added this line to fix the error
  const [cartCount, setCartCount] = useState(0);
  const [signupType, setSignupType] = useState("personal");

  const [termsAccepted, setTermsAccepted] = useState(false); // ✅ Track checkbox
  const [showContainer, setShowContainer] = useState(false);
  // State for drawer
  const [drawerOpen, setDrawerOpen] = useState(false);
  function handleSignInClick() {
    setShowLogin(true);
    // call your other function here if needed
    // someOtherFunction();
  }
  // Function for profile handling
  const handleProfile = () => {
    console.log("Profile button clicked");
    navigate("/profilepage");
  };
  // Function to fetch accurate cart items count from backend
  const fetchCartCount = async () => {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("authToken");

    if (!userId || !token) {
      setCartCount(0);
      return;
    }

    try {
      const cartUrl = `https://backend.maamaas.com/food/api/cart/${userId}/without-seating`;
      const response = await axios.get(cartUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("🛒 Full cart response for count:", response.data);

      let totalItems = 0;

      // Handle different response formats from your backend
      if (Array.isArray(response.data) && response.data.length > 0) {
        // Format 1: Array with cart objects
        const cartItems = response.data[0]?.cartItems || [];
        totalItems = cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
        console.log("📊 Count from array format:", totalItems);
      } else if (response.data && response.data.cartItems) {
        // Format 2: Object with cartItems array
        totalItems = response.data.cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
        console.log("📊 Count from object format:", totalItems);
      } else if (Array.isArray(response.data)) {
        // Format 3: Direct array of cart items
        totalItems = response.data.reduce((sum, item) => sum + (item.quantity || 0), 0);
        console.log("📊 Count from direct array format:", totalItems);
      } else if (response.data && typeof response.data === 'object') {
        // Format 4: Single cart object
        const cartItems = response.data.cartItems || [];
        totalItems = cartItems.reduce((sum, item) => sum + (item.quantity || 0), 0);
        console.log("📊 Count from single object format:", totalItems);
      }

      console.log("✅ Final cart count:", totalItems);
      setCartCount(totalItems);

    } catch (error) {
      if (error.response?.status === 404) {
        console.log("🛒 No cart found - setting count to 0");
        setCartCount(0);
      } else {
        console.error("❌ Error fetching cart count:", error);
        setCartCount(0); // Set to 0 on error
      }
    }
  };
  // Manual refresh function (can be called from other components)
  const refreshCartCount = () => {
    if (isLoggedIn) {
      fetchCartCount();
    }
  };

  // Auto-refresh every 60 seconds when user is on the page
  useEffect(() => {
    if (isLoggedIn) {
      fetchCartCount();   // Run only once
    }
  }, [isLoggedIn]);

  // Fetch cart count when component mounts and when login state changes
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const userId = localStorage.getItem("userId");

    if (token && userId) {
      setIsLoggedIn(true);
      fetchCartCount(); // Fetch actual count from backend
    } else {
      setIsLoggedIn(false);
      setCartCount(0);
    }
  }, []);

  // Refresh cart count when user logs in
  useEffect(() => {
    if (isLoggedIn) {
      console.log("🔄 User logged in, fetching cart count...");
      fetchCartCount();
    } else {
      console.log("🔒 User logged out, resetting cart count to 0");
      setCartCount(0);
    }
  }, [isLoggedIn]);

  // Optional: Refresh cart count when page becomes visible (tab switch)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && isLoggedIn) {
        console.log("📱 Page visible, refreshing cart count");
        fetchCartCount();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isLoggedIn]);


  const handleNavigate = () => {
    navigate("/cartsdata");
  };

  const handleLogout = () => {
    // Remove login status from localStorage

    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("authToken"); // if you are storing token
    localStorage.removeItem("vendorId");  // optional, clear session data

    // Update state
    setIsLoggedIn(false);
    setShowContainer(false);
    navigate("/");

    console.log("✅ Logged out successfully");
  };

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setShowMobileMenu(false);
      }
    };

    const handleScroll = () => setScrolled(window.scrollY > 50);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleChange = (e) => {
    setLoginObj({ ...loginObj, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");

    // ✅ Check if terms not accepted
    if (!termsAccepted) {
      setError("Please select Terms and Conditions");
      return;
    }
    setIsLoading(true);
    // Map signupType to backend expected enums
    const userType = signupType === "personal" ? "PERSONAL" : "PROFESSIONAL";

    const requestBody = {
      userName: loginObj.userName,
      emailId: loginObj.emailId,
      password: loginObj.password,
      referralCodeUsed: loginObj.referralCodeUsed || null, // ✅ always send null if empty
      mobileNumber: loginObj.mobileNumber,
      companyName: loginObj.companyName || null,
      role: "ROLE_USER",
      userType: userType, // PERSONAL / PROFESSIONAL
      termsAndConditions: termsAccepted, // ✅ send true if checked
    };

    console.log("📌 Signup Request Body:", requestBody);

    const apiUrl =
      "https://backend.maamaas.com/subscription/api/user/registration";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      console.log("📌 Response Status:", response.status);

      const result = await response.json().catch(() => ({}));
      console.log("📌 Response Body:", result);

      if (response.ok) {
        alert("Signup successful!");
        setIsSignup(false);
        setIsForgot(false);
      } else {
        setError(result.message || "Signup failed");
      }
    } catch (error) {
      console.error("❌ Error during signup:", error);
      setError("Something went wrong. Please try again.");
    }

    setIsLoading(false);
  };

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setLoginObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      // ✅ Create URL with query parameters
      const url = `https://backend.maamaas.com/subscription/api/auth/login/user?identifier=${encodeURIComponent(
        loginObj.identifier
      )}&password=${encodeURIComponent(loginObj.password)}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          accept: "*/*",
        },
      });

      // ✅ Try to parse JSON safely
      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        console.error("❌ Server did not return JSON:", text);
        throw new Error("Invalid JSON response from server");
      }

      console.log("🔹 Login API Response:", data);

      if (response.ok && data.token) {
        // ✅ Store both tokens and user details
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("refreshToken", data.refreshToken);
        localStorage.setItem("userId", data.userId);
        localStorage.setItem("userType", data.userType || "");
        localStorage.setItem("professionalUserId", data.professionalUserId);
        localStorage.setItem("role", data.role);
        localStorage.setItem("isLoggedIn", "true");

        alert("Login successful!");
        setIsLoggedIn(true);
        setShowLogin(false);
        navigate("/homepage");
      } else {
        setError(data.message || "Login failed. Please try again.");
      }
    } catch (error) {
      console.error("❌ Login error:", error);
      setError("Email or Password wrong. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };


  // In your top-level component (Navbar, Header, etc.)
  useEffect(() => {
    const checkLogin = () => {
      const loggedIn = localStorage.getItem("isLoggedIn") === "true";
      setIsLoggedIn(loggedIn);
    };

    checkLogin(); // run on mount

    window.addEventListener("storage", checkLogin); // sync across tabs/components

    return () => {
      window.removeEventListener("storage", checkLogin);
    };
  }, []);


  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const getColoredText = (text) => {
    const words = text.split(" ");
    const half = Math.ceil(words.length / 2);
    return (
      <>
        <span style={{ color: "#FFD700" }}>{words.slice(0, half).join(" ")} </span>
        <span style={{ color: "white" }}>{words.slice(half).join(" ")}</span>
      </>
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // if page scrolled more than 50px, set true
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const response = await axios.post(
        "https://backend.maamaas.com/food/api/forgot/password",
        {
          identifier: email, // backend expects `identifier`
        }
      );

      if (response.status === 200) {
        setMessage("Reset link sent successfully to your email.");
        setIsEmailSubmitted(true);
      } else {
        setMessage("Something went wrong. Please try again.");
      }
    } catch (error) {
      setMessage(
        error.response?.data?.message ||
        "Error while sending reset link. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleLogoClick = () => {
    navigate("/homepage");
  };

  const styles = {
    section: {
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#b15cd6",

    },
    navbar: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "8px 20px",
      backgroundColor: "#b15cd6",
      zIndex: 1000,
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    },
    logo: {
      fontSize: isMobile ? "24px" : "30px",
      fontWeight: "bold",
      fontFamily: "roboto",
      color: "white",
      cursor: 'pointer',
      marginRight: isMobile ? "0" : "20px",
    },
    navButtons: {
      display: isMobile ? (showMobileMenu ? "flex" : "none") : "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      gap: isMobile ? "10px" : "15px",
      position: isMobile ? "absolute" : "relative",
      top: isMobile ? "60px" : "auto",
      right: isMobile ? "20px" : "auto",
      backgroundColor: isMobile ? "rgb(177, 92, 214)" : "transparent",
      padding: isMobile ? "15px" : "0",
      borderRadius: isMobile ? "5px" : "0",
      boxShadow: isMobile ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
      width: isMobile ? "200px" : "auto",
    },
    navButton: {
      backgroundColor: "transparent",
      color: "white",
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "bold",
      border: "none",
      cursor: "pointer",
      padding: isMobile ? "6px 8px" : "8px 12px",
      borderRadius: "5px",
      transition: "all 0.3s ease",
      textAlign: isMobile ? "left" : "center",
      width: isMobile ? "100%" : "auto",
    },
    signInButton: {
      backgroundColor: "rgba(42, 9, 71, 1)",
      color: "white",
      fontSize: isMobile ? "14px" : "16px",
      fontFamily: "Lato, sans-serif",
      fontWeight: "bold",
      borderRadius: "16px",
      width: isMobile ? "80px" : "90px",
      height: isMobile ? "36px" : "40px",
      border: "none",
      cursor: "pointer",
      marginLeft: isMobile ? "auto" : "0",
    },
    mobileMenuButton: {
      backgroundColor: "transparent",
      border: "none",
      color: "white",
      fontSize: "24px",
      cursor: "pointer",
      display: isMobile ? "block" : "none",
    },
    topText: {
      textAlign: "center",
      marginBottom: "40px",
    },
    topH2: {
      fontSize: isMobile ? "30px" : "50px",
      marginBottom: "5px",
      fontWeight: "bold",
      color: "white",
    },
    topP: {
      fontSize: isMobile ? "30px" : "50px",
      fontWeight: "bold",
      color: "white",
    },
    contentContainer: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "20px",
      marginBottom: "40px",
      marginTop: isMobile ? "0" : "-98px",
    },
    textSection: {
      flex: 1,
      minWidth: "280px",
      marginTop: isMobile ? "0" : "-25px",
    },
    textH3: {
      fontSize: isMobile ? "28px" : "40px",
      marginBottom: "10px",
      color: "white",
      fontWeight: "bold",
      textAlign: isMobile ? "center" : "left",
      marginLeft: isMobile ? "0" : "53px",
    },
    textP: {
      fontSize: isMobile ? "16px" : "20px",
      color: "white",
      textAlign: isMobile ? "center" : "left",
      fontWeight: isMobile ? "normal" : "bold",
      fontFamily: "revert",
      padding: isMobile ? "0 10px" : "0",
    },
    imageSection: {
      flex: 1,
      textAlign: "center",
      marginTop: isMobile ? "20px" : "40px",
    },
    image: {
      maxWidth: "100%",
      height: isMobile ? "auto" : "385px",
      borderRadius: "10px",
      marginTop: isMobile ? "0" : "-64px",
    },
    counterContainer: {
      display: "flex",
      justifyContent: "space-around",
      flexWrap: "wrap",
      gap: "20px",
      borderTop: "1px solid #ddd",
      paddingTop: "20px",
    },
    buttonContainer: {
      marginTop: "20px",
    },
    downloadBtn: {
      backgroundColor: "rgba(42, 9, 71, 1)",
      color: "rgb(42 9 71)4",
      padding: "12px 25px",
      fontSize: isMobile ? "16px" : "20px",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "0.3s ease",
      fontWeight: "bold",
      zIndex: "10",
    },
    popupOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    popupInner: {
      background: "white",
      padding: "30px",
      borderRadius: "10px",
      textAlign: "center",
      position: "relative",
      maxWidth: "400px",
      animation: "slideUp 0.4s ease",
      zIndex: 1001,
      pointerEvents: "auto",
    },
    closeBtn: {
      position: "absolute",
      top: "10px",
      right: "15px",
      fontSize: "20px",
      background: "none",
      border: "none",
      cursor: "pointer",
    },
    scannerImg: {
      width: "200px",
      height: "auto",
      marginBottom: "15px",
    },
    loginForm: {
      position: "fixed",
      top: isMobile ? "65px" : "75px",
      right: showLogin ? "0" : "-100%",
      width: "100%",
      maxWidth: isMobile ? "90%" : "400px",
      height: isMobile ? "90vh" : "76vh",
      backgroundColor: "white",
      borderRadius: "20px",
      padding: isMobile ? "20px 15px" : "40px 30px",
      boxShadow: "-5px 0 15px rgba(0, 0, 0, 0.1)",
      transition: "right 0.5s ease-in-out",
      zIndex: 1000,
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      overflowY: "auto",
    },
    welcomeText: {
      textAlign: "justify",
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: "1.8",
      fontFamily: "Roboto, sans-serif",
      fontWeight: "400",
      margin: "0 auto",
      width: isMobile ? "95%" : "90%",
      color: "white",
    }
  };

  return (
    <div style={styles.section}>
      {/* Fixed Navbar */}
      <div style={styles.navbar}>
        <div
          style={styles.logo}
          onClick={handleLogoClick}
          className="clickable-logo"
        >
          MAAMAA'S
        </div>

        {isMobile && (
          <button
            style={styles.mobileMenuButton}
            onClick={() => setShowMobileMenu(!showMobileMenu)}
          >
            {showMobileMenu ? '✕' : '☰'}
          </button>
        )}

        <div style={styles.navButtons}>
          {isLoggedIn ? (
            <>
              {/* Notification Icon */}
              <IconButton sx={{ color: "white" }}>
                {/* <NotificationsIcon fontSize="large" /> */}
              </IconButton>

              {/* Cart Icon */}
              {/* Cart Icon with Count */}
              {/* Cart Icon with Accurate Count from Backend */}
              <IconButton
                sx={{
                  color: "white",
                  position: "relative",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)"
                  }
                }}
                onClick={handleNavigate}
                title={`${cartCount} items in cart`}
              >
                <Badge
                  badgeContent={cartCount}
                  color="error"
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: "#ff4081",
                      color: "white",
                      borderRadius: "50%",
                      minWidth: "20px",
                      height: "20px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      top: "8px",
                      right: "8px",
                      border: "2px solid #b15cd6",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    },
                  }}
                >
                  <ShoppingCartIcon
                    fontSize="large"
                    sx={{
                      fontSize: "28px",
                      transition: "all 0.3s ease",
                    }}
                  />
                </Badge>
              </IconButton>

              {/* Profile Icon */}
              <IconButton
                onClick={() => setShowContainer(!showContainer)}
                sx={{ color: "white" }}
              >
                <AccountCircleIcon fontSize="large" />
              </IconButton>

              {/* Dropdown Menu */}
              {showContainer && (
                <Paper
                  sx={{
                    position: "fixed",
                    top: "60px",
                    right: "10px",
                    width: "120px",
                    backgroundColor: "white",
                    boxShadow: 3,
                    borderRadius: "8px",
                    zIndex: 1000,
                  }}
                >
                  {/* <MenuItem onClick={handleProfile}>Profile</MenuItem> */}
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Paper>
              )}
            </>
          ) : (
            <>
              {/* Signin Button */}
              <SliderComponent setShowLogin={setShowLogin} />
            </>
          )}
        </div>
      </div>

      {/* Login Form Popup */}
      <div style={styles.loginForm}>
        {/* Close Button */}
        <button
          style={{
            position: "absolute",
            top: "15px",
            right: "20px",
            fontSize: "28px",
            background: "none",
            border: "none",
            color: "#333",
            cursor: "pointer",
          }}
          onClick={() => {
            setShowLogin(false);
            setIsForgot(false);
            setIsSignup(false);
          }}
        >
          &times;
        </button>

        <p
          style={{
            marginBottom: 0,
            fontFamily: "revert",
            fontSize: isMobile ? "18px" : "22px",
            color: "#2a0947",
            fontWeight: "bold",
          }}
        >
          WELCOME TO MAAMAA'S
        </p>

        {/* Login Form */}
        {/* Login Form */}
        {!isSignup && !isForgot && (
          <>
            <form
              onSubmit={handleLogin}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <input
                type="text"
                placeholder="User ID"
                name="identifier"
                value={loginObj.identifier}
                onChange={handleChanges}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />

              <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  value={loginObj.password}
                  onChange={handleChanges}
                  style={{
                    padding: "10px",
                    paddingRight: "40px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#888"
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div style={{ textAlign: "right" }}>
                <span
                  onClick={() => setIsForgot(true)}   // 🔑 Ye toggle karega forgot form ko
                  style={{
                    color: "#007bff",
                    fontSize: "14px",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  Forget Password?
                </span>
              </div>
              {error && (
                <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
              )}
              <button
                type="submit"
                style={{
                  backgroundColor: "rgb(42 9 71)",
                  color: "white",
                  fontWeight: "bold",
                  padding: "12px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
                disabled={isLoading}
              >
                {isLoading ? "Logging in..." : "LOGIN"}
              </button>
            </form>
          </>
        )}

        {/* Forgot Password Form */}
        {isForgot && !isEmailSubmitted && (
          <form onSubmit={handleSubmit}>
            <div>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                required
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  marginBottom: "10px",
                  width: "100%",
                }}
              />
            </div>

            <button
              type="submit"
              style={{
                backgroundColor: "rgb(42 9 71)",
                color: "white",
                fontWeight: "bold",
                padding: "12px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                width: "100%",
              }}
              disabled={loading}
            >
              {loading ? "Sending..." : "Submit"}
            </button>

            {/* Back to login link */}
            <div style={{ marginTop: "10px", textAlign: "center" }}>
              <span
                onClick={() => setIsForgot(false)}   // 🔙 Isse wapas login dikhega
                style={{
                  color: "#007bff",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Back to Login
              </span>
            </div>
          </form>
        )}

        {/* Success/Error Message */}
        {message && (
          <div
            style={{
              marginTop: "15px",
              padding: "10px",
              borderRadius: "6px",
              textAlign: "center",
              color: message.includes("successfully") ? "green" : "red",
              fontWeight: "bold",
            }}
          >
            {message}
          </div>
        )}

        {/* Signup Form */}
        {isSignup && (
          <>
            {/* Signup Type Selector */}
            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              <label>
                <input
                  type="radio"
                  name="signupType"
                  value="personal"
                  checked={signupType === "personal"}
                  onChange={() => setSignupType("personal")}
                />{" "}
                Personal
              </label>
              <label>
                <input
                  type="radio"
                  name="signupType"
                  value="professional"
                  checked={signupType === "professional"}
                  onChange={() => setSignupType("professional")}
                />{" "}
                Professional
              </label>
            </div>

            <form
              onSubmit={handleSignup}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <input
                type="text"
                name="userName"
                placeholder="Name"
                value={loginObj.userName}
                onChange={handleChange}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />
              <input
                type="email"
                name="emailId"
                placeholder="Email"
                value={loginObj.emailId}
                onChange={handleChange}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />
              <input
                type="text"
                name="mobileNumber"
                placeholder="Phone Number"
                value={loginObj.mobileNumber}
                onChange={handleChange}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />

              {/* Show companyName only for Professional */}
              {signupType === "professional" && (
                <input
                  type="text"
                  name="companyName"
                  placeholder="Company Name"
                  value={loginObj.companyName}
                  onChange={handleChange}
                  style={{
                    padding: "10px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
              )}

              {/* Password Field */}
              <div
                style={{ position: "relative", display: "inline-block", width: "100%", marginBottom: "15px" }}
              >
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Create Password"
                  value={loginObj.password}
                  onChange={handleChange}
                  style={{
                    padding: "10px",
                    fontSize: "16px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                />
                <span
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#888",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              {/* Referral Code Field */}
              <div style={{ width: "100%", marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#444",
                    marginBottom: "6px",
                  }}
                >
                  🎁 Have a Referral Code?
                </label>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    type="text"
                    name="referralCode"
                    placeholder="Enter your referral code "
                    value={loginObj.referralCodeUsed}
                    onChange={handleChange}
                    style={{
                      padding: "12px 40px 12px 12px",
                      fontSize: "16px",
                      border: "2px dashed #7c3aed", // dashed border highlight
                      borderRadius: "8px",
                      width: "100%",
                      boxSizing: "border-box",
                      backgroundColor: "#f9f5ff", // light purple background
                      fontWeight: "500",
                      color: "#111",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: "50%",
                      right: "12px",
                      transform: "translateY(-50%)",
                      fontSize: "18px",
                      color: "#7c3aed",
                      fontWeight: "bold",
                    }}
                  >
                    %
                  </span>
                </div>
                <small style={{ color: "#6b7280", fontSize: "12px" }}>
                  Apply referral code & unlock exciting rewards!
                </small>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "6px",
                  fontSize: "14px",
                  lineHeight: "20px",
                }}
              >
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                />
                <span>I hereby agree to the</span>
                <a
                  href="/termsandconditions"

                  rel="noopener noreferrer"
                  style={{ color: "#007bff", textDecoration: "none" }}
                >
                  Terms & Conditions
                </a>
                <span>and</span>
                <a
                  href="/gaming"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007bff", textDecoration: "none" }}
                >
                  Privacy Policy
                </a>
                <span>of Maamaas</span>
              </div>

              <button
                type="submit"
                disabled={!termsAccepted || isLoading}
                style={{
                  backgroundColor: !termsAccepted ? "gray" : "rgb(42 9 71)",
                  color: "white",
                  fontWeight: "bold",
                  padding: "12px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: !termsAccepted ? "not-allowed" : "pointer",
                }}
              >
                {isLoading ? "Signing up..." : "SIGN UP"}
              </button>

              {error && (
                <div style={{ color: "red", marginTop: "10px" }}>{error}</div>
              )}
            </form>

          </>
        )}

        {/* Switch Between Login & Signup */}
        {!isForgot && (
          <div style={{ textAlign: "center" }}>
            <p style={{ fontSize: "14px" }}>
              {isSignup
                ? "Already have an account?"
                : "Don't have an account?"}{" "}
              <span
                onClick={() => {
                  setIsSignup(!isSignup);
                  setIsForgot(false);
                }}
                style={{
                  color: "rgb(42 9 71)",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                {isSignup ? "Login here" : "Sign up"}
              </span>
            </p>

          </div>
        )}
      </div>

      {/* Main Content */}
      {/* Content */}

    </div>
  );
};

export default NavBars;